import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage, dashboardBeforeLoad, dashboardSearchSchema } from '@/pages/dashboard';

export const Route = createFileRoute('/dashboard')({
    validateSearch: dashboardSearchSchema,
    beforeLoad: dashboardBeforeLoad,
    component: DashboardPage,
});
